/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AiStreamRouteImport } from './routes/ai-stream'
import { Route as AllChatsRouteImport } from './routes/all-chats'
import { Route as CompleteRouteImport } from './routes/complete'
import { Route as MyChatsRouteImport } from './routes/my-chats'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthLogoutRouteImport } from './routes/auth/logout'
import { Route as FlowSessionSessionIdRouteImport } from './routes/flow-session/$sessionId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AiStreamRoute = AiStreamRouteImport.update({
  id: '/ai-stream',
  path: '/ai-stream',
  getParentRoute: () => rootRouteImport,
} as any)
const AllChatsRoute = AllChatsRouteImport.update({
  id: '/all-chats',
  path: '/all-chats',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteRoute = CompleteRouteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => rootRouteImport,
} as any)
const MyChatsRoute = MyChatsRouteImport.update({
  id: '/my-chats',
  path: '/my-chats',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const FlowSessionSessionIdRoute = FlowSessionSessionIdRouteImport.update({
  id: '/flow-session/$sessionId',
  path: '/flow-session/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai-stream': typeof AiStreamRoute
  '/all-chats': typeof AllChatsRoute
  '/complete': typeof CompleteRoute
  '/my-chats': typeof MyChatsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/flow-session/$sessionId': typeof FlowSessionSessionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai-stream': typeof AiStreamRoute
  '/all-chats': typeof AllChatsRoute
  '/complete': typeof CompleteRoute
  '/my-chats': typeof MyChatsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/flow-session/$sessionId': typeof FlowSessionSessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai-stream': typeof AiStreamRoute
  '/all-chats': typeof AllChatsRoute
  '/complete': typeof CompleteRoute
  '/my-chats': typeof MyChatsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/flow-session/$sessionId': typeof FlowSessionSessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai-stream'
    | '/all-chats'
    | '/complete'
    | '/my-chats'
    | '/auth/login'
    | '/auth/logout'
    | '/flow-session/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai-stream'
    | '/all-chats'
    | '/complete'
    | '/my-chats'
    | '/auth/login'
    | '/auth/logout'
    | '/flow-session/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/ai-stream'
    | '/all-chats'
    | '/complete'
    | '/my-chats'
    | '/auth/login'
    | '/auth/logout'
    | '/flow-session/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiStreamRoute: typeof AiStreamRoute
  AllChatsRoute: typeof AllChatsRoute
  CompleteRoute: typeof CompleteRoute
  MyChatsRoute: typeof MyChatsRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  FlowSessionSessionIdRoute: typeof FlowSessionSessionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-stream': {
      id: '/ai-stream'
      path: '/ai-stream'
      fullPath: '/ai-stream'
      preLoaderRoute: typeof AiStreamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/all-chats': {
      id: '/all-chats'
      path: '/all-chats'
      fullPath: '/all-chats'
      preLoaderRoute: typeof AllChatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete': {
      id: '/complete'
      path: '/complete'
      fullPath: '/complete'
      preLoaderRoute: typeof CompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-chats': {
      id: '/my-chats'
      path: '/my-chats'
      fullPath: '/my-chats'
      preLoaderRoute: typeof MyChatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flow-session/$sessionId': {
      id: '/flow-session/$sessionId'
      path: '/flow-session/$sessionId'
      fullPath: '/flow-session/$sessionId'
      preLoaderRoute: typeof FlowSessionSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiStreamRoute: AiStreamRoute,
  AllChatsRoute: AllChatsRoute,
  CompleteRoute: CompleteRoute,
  MyChatsRoute: MyChatsRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  FlowSessionSessionIdRoute: FlowSessionSessionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
